import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DatePicker from 'components/DatePicker/DatePicker';
import {
  DATE_CLOSED,
  DATE_OPENED,
} from 'constants/formFields';
import { DATE_FORMAT } from 'constants/general';

import FinancialFields from './FinancialFields';

import type { IFinancialAndDatesInfo } from '../interfaces/IFinancialAndDatesInfo';

import styles from '../sass/CreateCustomerView.module.scss';

function FinancialAndDatesInfo({
  control,
  placeholder,
  dateOpened,
  onChangeDate,
}: IFinancialAndDatesInfo) {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <FinancialFields
        control={control}
        placeholder={placeholder}
      />

      <Controller
        control={control}
        name={DATE_OPENED}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <DatePicker
            label={t('customers.fields.dateOpened')}
            error={error?.message}
            onChange={(date) => onChangeDate(date, onChange)}
            name={name}
            value={value}
            placeholder={placeholder || DATE_FORMAT}
            maxDate={new Date()}
            required
          />
        )}
      />
      <Controller
        control={control}
        name={DATE_CLOSED}
        render={({
          field: {
            name,
            value,
            onChange,
          },
          fieldState: { error },
        }) => (
          <DatePicker
            label={t('customers.fields.dateClosed')}
            error={error?.message}
            onChange={onChange}
            name={name}
            value={value}
            minDate={dateOpened}
            placeholder={placeholder || DATE_FORMAT}
          />
        )}
      />
    </div>
  );
}

export default FinancialAndDatesInfo;
